export enum AvailableSections {
    Closet = 'closet',
    Collections = 'collections',
    Looks = 'looks',
    Photos = 'photos'
}
export const baseURL = '/profile';
